/**
 * Opções de programação do Encaminhar chamado (Board), espelho do Programar atendimento (Checkout).
 */
export const BOARD_ENCAMINHAR_SCHEDULE_OPTIONS = [
  {
    id: 'today',
    label: 'Programar para hoje',
    groupName: 'Previsto para hoje',
    icon: 'bi bi-calendar-day',
  },
  {
    id: 'tomorrow',
    label: 'Programar para amanhã',
    groupName: 'Previstas para amanhã',
    icon: 'bi bi-calendar-week',
  },
  {
    id: 'future',
    label: 'Agendamento futuro',
    groupName: 'FUTURA',
    icon: 'bi bi-calendar-event',
  },
  {
    id: 'apenas_tecnico',
    label: 'Apenas definir técnico',
    groupName: 'Em Aberto',
    icon: 'bi bi-person',
  },
];

export function getBoardEncaminharScheduleOption(id) {
  return BOARD_ENCAMINHAR_SCHEDULE_OPTIONS.find((o) => o.id === id) || null;
}

/**
 * Estrutura vazia de seções do técnico no Board (quando o tech ainda não tem coluna carregada).
 */
export function createEmptyTechnicianBoardGroups() {
  return {
    'Em deslocamento': [],
    'Em serviço': [],
    'Previsto para hoje': [],
    'Previstas para amanhã': [],
    FUTURA: [],
    PENDENTE: [],
    LIBERADO: [],
  };
}
